export default class ModelText {
  _txt;
  _font;
  _posX;
  _posY;
  _width;
  _height;
  _angle;
  _parent;

  constructor(txt, font, posX, posY, width, height, angle, parent) {
    this._txt = txt;
    this._font = font;
    this._posX = posX;
    this._posY = posY;
    this._width = width;
    this._height = height;
    this._angle = angle;
    this._parent = parent;
  }

  get txt() {
    return this._txt;
  }

  set txt(value) {
    this._txt = value;
  }

  get font() {
    return this._font;
  }

  set font(value) {
    this._font = value;
  }

  get posX() {
    return this._posX;
  }

  set posX(value) {
    this._posX = value;
  }

  get posY() {
    return this._posY;
  }

  set posY(value) {
    this._posY = value;
  }

  get width() {
    return this._width;
  }

  set width(value) {
    this._width = value;
  }

  get height() {
    return this._height;
  }

  set height(value) {
    this._height = value;
  }

  get angle() {
    return this._angle;
  }

  set angle(value) {
    this._angle = value;
  }

  get parent() {
    return this._parent;
  }

  set parent(value) {
    this._parent = value;
  }

}
